// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Orj1","productName":"Table_productName__3v5MP"};